import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as api from '../../../../../../api/generated';
import { KendoLoading } from '../../../../../../components';
import ListItemCreateButton from '../../../../../../components/custom/ListItemCreateButton';
import { useConfirmation } from '../../../../../../components/dialogs';
import { usePageableGrid } from '../../../../../../components/hooks/usePageableGrid';
import { Grid, GridColumn } from '../../../../../../components/KendoReact/Grid';
import { useWindow } from '../../../../../../components/windows/WindowContext';
import { waitingTimesWarningType } from '../../../../../../enums';
import AdministrationActionCell from '../../../components/AdministrationActionCell';
import { ISettings } from '../../GeneralSettingsPage';
import UserWarningOfWaitingTimesCreateWindow from './UserWarningOfWaitingTimesCreateWindow';
import UserWarningOfWaitingTimesEditWindow from './UserWarningOfWaitingTimesEditWindow';
interface IProps {
    settings: ISettings | null;
    fetchData: () => Promise<void>;
}

const GeneralSettingsUsersWarningOfWaitingTimes: FC<IProps> = (props) => {
    const { confirmAsync } = useConfirmation();
    const [isLoading, setIsLoading] = useState(false);
    const [gridPageProps] = usePageableGrid([5, 10, 15, 20, 25], 15);
    const { openWindow } = useWindow();
    const { organizationInformationId } = useParams<'organizationInformationId'>();

    const handleDelete = async (id: number) => {
        try {
            const { success } = await confirmAsync('El. pašto ištrynimas', 'Ar tikrai norite ištrinti pasirinktą el. paštą?');

            if (!success) {
                return;
            }

            await api.administration.deleteUserWarningOfWaitingTime(id);
            toast.success('Įrašas sėkmingai ištrintas');
            props.fetchData();
        } catch (ex) {
            toast.error('Ištrinti įrašo nepavyko');
        }
    };

    const openUserWarningOfWaitingTimesEditWindow = async (itemId: number) => {
        try {
            UserWarningOfWaitingTimesEditWindow.defaultProps = {
                componentProps: {
                    fetchData: props.fetchData,
                    organizationInformationId: parseInt(organizationInformationId.toString()),
                    editableItem: props.settings.usersWarningOfWaitingTimes.find((e) => e.id === itemId)
                }
            };
            openWindow({
                title: 'Įrašo įspėjimui apie kritinius laikus redagavimas',
                component: UserWarningOfWaitingTimesEditWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const openUserWarningOfWaitingTimesCreateWindow = async () => {
        try {
            UserWarningOfWaitingTimesCreateWindow.defaultProps = {
                componentProps: {
                    fetchData: props.fetchData,
                    organizationInformationId: parseInt(organizationInformationId.toString())
                }
            };
            openWindow({
                title: 'Sukurti įrašą įspėjimui apie kritinius laikus',
                component: UserWarningOfWaitingTimesCreateWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    if (isLoading) {
        <KendoLoading />;
    }
    return (
        <>
            {props.settings && (
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <ListItemCreateButton openCreateModal={openUserWarningOfWaitingTimesCreateWindow} />
                        <Grid className="mt-2" {...gridPageProps} data={props.settings.usersWarningOfWaitingTimes}>
                            <GridColumn
                                width={100}
                                title="Veiksmai"
                                cell={(c) => (
                                    <AdministrationActionCell
                                        {...c}
                                        fetchData={props.fetchData}
                                        deleteItem={handleDelete}
                                        editItem={openUserWarningOfWaitingTimesEditWindow}
                                    />
                                )}
                            />
                            <GridColumn title="El. paštas" width={200} field="email" />
                            <GridColumn
                                title="Įspėjimo tipas"
                                width={200}
                                field="waitingTimesWarningType"
                                cell={(c) => <td>{waitingTimesWarningType.format(c.dataItem.waitingTimesWarningType)}</td>}
                            />
                            <GridColumn
                                title="Įspėjimo apie paslaugą/padalinį pavad."
                                width={300}
                                field="locationName/serviceName"
                                cell={(c) => (
                                    <td>
                                        {waitingTimesWarningType.WarningForService === c.dataItem.waitingTimesWarningType
                                            ? `(Paslauga) ${c.dataItem.serviceName}`
                                            : `(Padalinys) ${c.dataItem.locationName}`}
                                    </td>
                                )}
                            />
                            <GridColumn
                                title="Paciento laukimo laikas"
                                width={200}
                                field="patientWaitingTime"
                                cell={(c) => <td>{c.dataItem.patientWaitingTime} min</td>}
                            />
                            <GridColumn
                                title="Paciento aptarnavimo laikas"
                                field="patientAttendanceTime"
                                cell={(c) => <td>{c.dataItem.patientAttendanceTime} min</td>}
                            />
                        </Grid>
                    </div>
                </div>
            )}
        </>
    );
};

export default GeneralSettingsUsersWarningOfWaitingTimes;
